import styled from 'styled-components'

export const StyledApp = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-image: linear-gradient(to bottom right, #424d85 0%, #222951 100%);
  padding-top: 60px;
  justify-content: center;
  max-width: 100vw;
  overflow: hidden;


  @media (max-width: 600px) {
    padding-top: 100px;
  }

  @media (max-width: 420px) {
    padding-top: 89px;
  }
`
